export default {
  loadingNumber: '??',
  loadingText: 'Loading...'
};



// WEBPACK FOOTER //
// ./src/globals.js